import * as React from 'react'
const SvgComponent = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={42} height={28} fill="none">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16.286 14.143h-4.408a3.3 3.3 0 0 1-1.688-.414c-.52-.287-.96-.71-1.277-1.227L3.857 3.857H7.2l4.68 3.429h22.835a3.429 3.429 0 0 1 0 6.857h-8.571"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m18.061 12.428-2.204 1.715 2.204 1.714h8.082v-3.428h-8.082Zm-7.346-1.714h-6m24.857 15.428a2.571 2.571 0 1 1 1.844-4.362 3.428 3.428 0 1 1 3.298 4.362zM9 18.428a2.57 2.57 0 0 0-2.514 2.02 1.67 1.67 0 0 0-.914-.305 1.715 1.715 0 0 0 0 3.428H9a2.571 2.571 0 1 0 0-5.143"
    />
  </svg>
)
export default SvgComponent
